import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaCt010 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {}

    // API Response
    export interface Response {
      akamaiToken: string
    }
  }

  // API Path
  const path: string = '/ta/akamaiTokens'

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        akamaiToken: '',
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path, params),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
